import { ROUTE_RESULT_LIST_BASE_PATH } from 'utils/enums';
import localGeoApiClient from 'api/localGeoApiClient';
import PrettyUrlsResultList from './classes/PrettyUrlsResultList';
import sanitize from './querySanitizer';

const prettyUrlsResultList = new PrettyUrlsResultList(
  localGeoApiClient,
  { sanitize },
  { mountPath: ROUTE_RESULT_LIST_BASE_PATH },
);

export default prettyUrlsResultList;
